module.exports = __webpack_public_path__ + "static/slide-06-7bc583ff517dc486059a07de1689c68c.png";